/* MK Domus - compartilhar e vistos recentemente */
(function () {
  var CHAVE = 'mk-vistos';
  var MAX = 12;

  function pronto(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function ler() {
    try { return JSON.parse(localStorage.getItem(CHAVE) || '[]'); } catch (e) { return []; }
  }
  function gravar(l) {
    try { localStorage.setItem(CHAVE, JSON.stringify(l.slice(0, MAX))); } catch (e) {}
  }

  pronto(function () {
    var titulo = document.querySelector('.mkp__title');
    var preco = document.getElementById('mkpPrice');
    var img = document.getElementById('mkpImg');
    var naProduto = !!(titulo && preco);

    /* ---------- registra o produto visto ---------- */
    if (naProduto) {
      var item = {
        u: window.location.pathname.split('?')[0],
        t: titulo.textContent.trim(),
        p: preco.textContent.trim(),
        i: img ? img.getAttribute('src') : ''
      };
      var lista = ler().filter(function (x) { return x.u !== item.u; });
      lista.unshift(item);
      gravar(lista);
    }

    /* ---------- botoes de compartilhar ---------- */
    if (naProduto) {
      var acoes = document.getElementById('mkpForm');
      if (acoes) {
        var url = window.location.origin + item.u;
        var texto = encodeURIComponent(item.t + ' — ' + item.p + '\n' + url);

        var barra = document.createElement('div');
        barra.className = 'mkshare';
        barra.innerHTML =
          '<span class="mkshare__cap">Compartilhar</span>' +
          '<a href="https://wa.me/?text=' + texto + '" target="_blank" rel="noopener">' +
            '<svg viewBox="0 0 24 24"><path d="M12 2.2A9.7 9.7 0 0 0 3.6 16.8L2.2 21.8l5.1-1.3A9.7 9.7 0 1 0 12 2.2z"/></svg>WhatsApp</a>' +
          '<button type="button" class="mkshare__copy">' +
            '<svg viewBox="0 0 24 24"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5h10"/></svg>Copiar link</button>';
        acoes.parentNode.insertBefore(barra, acoes.nextSibling);

        barra.querySelector('.mkshare__copy').addEventListener('click', function () {
          var b = this;
          var fim = function () {
            var antes = b.innerHTML;
            b.textContent = 'Link copiado';
            setTimeout(function () { b.innerHTML = antes; }, 1800);
          };
          if (navigator.clipboard) navigator.clipboard.writeText(url).then(fim, fim);
          else fim();
        });
      }
    }

    /* ---------- vistos recentemente ---------- */
    var vistos = ler().filter(function (x) { return x.u !== window.location.pathname.split('?')[0]; });
    if (vistos.length < 2) return;

    var ancora = document.querySelector('.mksoc') || document.querySelector('.mkfaq');
    if (!ancora) return;

    var sec = document.createElement('section');
    sec.className = 'mkvr';
    var html = '<h2 class="mkvr__h">Você viu recentemente</h2><div class="mkvr__rail">';
    vistos.slice(0, 10).forEach(function (x) {
      html += '<a class="mkvr__c" href="' + x.u + '">' +
        '<span class="mkvr__img">' + (x.i ? '<img src="' + x.i + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="mkvr__b"><span class="mkvr__n">' + x.t + '</span>' +
        '<span class="mkvr__p">' + x.p + '</span></span></a>';
    });
    html += '</div>';
    sec.innerHTML = html;
    ancora.parentNode.insertBefore(sec, ancora.nextSibling);
  });
})();
